import config from "../../../config/config";
import { authFetch, buildAuthHeaders } from "../../../public/api/httpClient";

const BASE = `${config.BASE_URL}/image-processing-settings`;

async function parseJson(res) {
  const text = await res.text();
  try {
    return text ? JSON.parse(text) : {};
  } catch {
    return { message: text || "Invalid response" };
  }
}

export async function getImageProcessingSettings() {
  const res = await authFetch(BASE, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const payload = await parseJson(res);
  if (!res.ok) {
    throw new Error(payload?.message || "Failed to load image processing settings");
  }
  return payload;
}

export async function updateImageProcessingSettings(payload) {
  const res = await authFetch(BASE, {
    method: "PUT",
    credentials: "include",
    headers: buildAuthHeaders(),
    body: JSON.stringify(payload || {}),
  });
  const parsed = await parseJson(res);
  if (!res.ok) {
    throw new Error(parsed?.message || "Failed to update image processing settings");
  }
  return parsed;
}

